export default __webpack_public_path__ + "static/media/element_55.493b6dd8.jpg";